/**
 * TanStack Query hooks for `nl-query-report-interface-ai-native`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	nlQueryReportInterfaceAiNativeQueryKeys,
	type CreateNlQueryReportInterfaceAiNativeBody,
	type ListNlQueryReportInterfaceAiNativeResponse,
	type NlQueryReportInterfaceAiNativeRow,
} from "./api";

export function useNlQueryReportInterfaceAiNativeList(): UseQueryResult<ListNlQueryReportInterfaceAiNativeResponse, Error> {
	return useQuery({
		queryKey: nlQueryReportInterfaceAiNativeQueryKeys.list(),
		queryFn: list,
	});
}

export function useNlQueryReportInterfaceAiNativeCreate(): UseMutationResult<NlQueryReportInterfaceAiNativeRow, Error, CreateNlQueryReportInterfaceAiNativeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nlQueryReportInterfaceAiNativeQueryKeys.all });
		},
	});
}

export function useNlQueryReportInterfaceAiNativeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nlQueryReportInterfaceAiNativeQueryKeys.all });
		},
	});
}
